import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loading from "../comps/Loading/Loading";
// import LoadComp from "../hocs/LoadComp";

const Layout = lazy(() => import("../views/Layout/Layout"));
// const Index = LoadComp(lazy(() => import("../views/Index/Index")));
// const Search = LoadComp(lazy(() => import("../views/Search/Search")));
// const UserCenter = LoadComp(
//     lazy(() => import("../views/UserCenter/UserCenter")),
// );
// const BoughtNotice = LoadComp(
//     lazy(() => import("../views/BoughtNotice/BoughtNotice")),
// );
// const Pay = LoadComp(lazy(() => import("../views/Pay/Pay")));
// const Analysis = LoadComp(lazy(() => import("../views/Analysis/Analysis")));

// const routes: RouteObject[] = [
//     {
//         path: "",
//         element: <Layout />,
//         children: [
//             {
//                 path: "/",
//                 element: <Index />,
//                 index: true,
//             },
//             {
//                 path: "/search",
//                 element: <Search />,
//             },
//             {
//                 path: "/user-center",
//                 element: <UserCenter />,
//             },
//             {
//                 path: "/bought-notice",
//                 element: <BoughtNotice />,
//             },
//             {
//                 path: "/pay",
//                 element: <Pay />,
//             },
//             {
//                 path: "/analysis/:id",
//                 element: <Analysis />,
//             },
//         ],
//     },
// ];

// const App = () => {
//     let element = useRoutes(routes);
//     console.log(element?.props);
//     console.log(React.Children.count(element?.props.children));
//     return element;
// };

export default () => {
    return (
        <BrowserRouter basename="ipo_radar">
            <Suspense fallback={<Loading />}>
                {/* <App /> */}
                <Routes>
                    <Route path="/*" element={<Layout />}></Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};
